var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandsintownSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1259_4933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7394 0H15V7.5H11.7394V0ZM7.82625 3.125H11.0869V7.5H7.82625V3.125ZM3.9125 3.125H7.17313V7.5H3.91313L3.9125 3.125ZM15 15H0V0H3.26062V11.875H11.7394V11.25H3.9125V8.125H15V15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1259_4933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandsintownSvgrepoCom);
export default __webpack_public_path__ + "static/media/bandsintown-svgrepo-com.1b83736d9385e9944a4f7ed22d578e17.svg";
export { ForwardRef as ReactComponent };